<template>
  <div class="information-box">
    <slot/>
    <div class="information"
         :class="{
                  'addAccounts':(type=='addAccounts'),
                  'addOrder':(type=='addOrder'),
                  'cancelOrder':(type=='cancelOrder'),
                  'addAccount':(type=='addAccount'),
                  'addUser':(type=='addUser'),
                  'resetUser':(type=='resetUser'),
                  'removeUser':(type=='removeUser'),
                  'contactDairy':(type=='contactDairy'),
                 }">
      <span class="text">{{ text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
  },
};
</script>

<style scoped>
.information-box {
  position: relative;
  display: inline-block;
}

.information {
  opacity: 0;
  font-size: 9pt;
  weight: normal;
  color: #ffffff;
  text-align: center;
  padding: 5px 0;
  border-radius: 2px;
  width: 80px;
  bottom: 100%;
  left: 50%;
  margin-left: -40px;
  transition: opacity 1s;
  position: absolute;
  z-index: 2;
  background: #a782e8;
}

.information-box:hover .information {
  opacity: 1;
  weight: bold;
}

.information::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: -5px;
  border-width: 6px;
  border-style: solid;
  border-color: transparent #a782e8 transparent transparent;
}

.addAccounts {
  bottom: 20%;
  margin-left: -95px;
}

.addAccounts::after {
  left: 100%;
  border-color: transparent transparent transparent #a782e8;
}

.addOrder {
  bottom: 20%;
  margin-left: -95px;
}

.addOrder::after {
  left: 100%;
  border-color: transparent transparent transparent #a782e8;
}

.cancelOrder {
  bottom: 20%;
  margin-left: -95px;
}

.cancelOrder::after {
  left: 100%;
  border-color: transparent transparent transparent #a782e8;
}

.addAccount {
  bottom:30%;
  margin-left: -95px;
}

.addAccount::after {
  left: 100%;
  border-color: transparent transparent transparent #a782e8;
}

.addUser {
  bottom:25%;
  margin-left: -95px;
}

.addUser::after {
  left: 100%;
  border-color: transparent transparent transparent #a782e8;
}

.resetUser {
  bottom:15%;
  margin-left: 10px;
}

.resetUser::after {
  left: -20%;
  border-color:  transparent #a782e8 transparent transparent;
}

.removeUser {
  bottom:20%;
  margin-left: -95px;
}

.removeUser::after {
  left: 100%;
  border-color: transparent transparent transparent #a782e8;
}

.contactDairy {
  bottom:20%;
  margin-left: -95px;
}

.contactDairy::after {
  left: 100%;
  border-color: transparent transparent transparent #a782e8;
}

</style>